import { EventEmitter } from '@angular/core';
var GenerateStepComponent = /** @class */ (function () {
    function GenerateStepComponent() {
        this.back = new EventEmitter();
        this.confirmRegenerate = new EventEmitter();
    }
    return GenerateStepComponent;
}());
export { GenerateStepComponent };
